import {IPlayer} from '../../../models/IPlayer';

export class MembersModal {
    static $inject: string[] = ['item'];
    item: IPlayer;
    constructor(item: IPlayer) {
        this.item = item;
    }  
}
